import { basicInsuranceCover } from './basicInsuranceCover';

const basicInsuranceItem = {
  id: '',
  insuranceCoversAttributes: [basicInsuranceCover],
  name: '',
  notes: ''
};

export default basicInsuranceItem;
